'use client';

import { memo, useEffect, useState } from 'react';
import { Action, City } from '../../models';
import { http } from '../../lib/api/http';
import { V4 } from '../../lib/api/urls';
import { Posts } from '../posts/posts';

function SimilarEventsBlockMemo({
  eventData,
  currentCity,
}: {
  eventData: Action;
  currentCity: City;
}) {
  const [eventsList, setEventsList] = useState<null | { results: Action[] }>(
    null
  );
  useEffect(() => {
    http
      .get(V4.similarEvents(eventData.id), {
        limit: 8,
        offset: 0,
      })
      .then((res) => setEventsList(res))
      .catch(() => setEventsList(null));
  }, [eventData]);
  if (!eventData) {
    return null;
  }

  return eventsList && eventsList.results?.length ? (
    <Posts
      title='Похожие мероприятия'
      actions={eventsList}
      href={['', currentCity.url, 'catalog', ''].join('/')}
    />
  ) : null;
}

export const SimilarEventsBlock = memo(
  SimilarEventsBlockMemo,
  (oldProps, newProps) => oldProps.eventData.id === newProps.eventData.id
);
